export default IconArrowMergeLeft => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-merge-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 8l4 -4l4 4" />
  <path d="M12 20v-16" />
  <path d="M6 18c4 -1.333 6 -4.667 6 -10" />
</svg>`;